;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingControls = Marionette.ItemView.extend({
		tagName: 'div',

		template: JST.TippingControls,

		initialize: function() {

			this.round_id = this.getOption('round_id');
			this.rounds = this.getOption('rounds');

			this.rounds.fetch({cache: true, expires: 60 }).done(_.bind(function() {
				this.filterRounds().setSelectedRound().render(true);
			}, this));

			$(document).on('mouseup', this.closeDropDown);
		},

		ui: {
			prev_round:         '.js-prev-round',
			next_round:         '.js-next-round',
			toggle_rounds_list: '.js-toggle-rounds-list',
			db_round:           '.js-db-round',
			save_tips:          '.js-save-tips',
			dropdown_body:      '.js-dropdown-body',
			body:               'body',
			doc:                'document'
		},

		events: {
			'click @ui.prev_round':         'prevRound',
			'click @ui.next_round':         'nextRound',
			'click @ui.toggle_rounds_list': 'toggleRoundsDropdown',
			'click @ui.db_round':           'changeRound',
			'click @ui.save_tips':          'callSaveList'
		},

		filterRounds() {
			if (!this.options.gauntlet_start_round) {
				return this;
			}
			this.rounds.reset(this.rounds.filter(round => round.id >= this.options.gauntlet_start_round))
			if (!this.options.gauntlet_end_round) {
				return this;
			}
			this.rounds.reset(this.rounds.filter(round => round.id <= this.options.gauntlet_end_round))
			return this;
		},

		closeDropDown: function(e) {
			var $container = $(".js-dropdown-body");
			if (!$container.is(e.target) && !$(e.target).hasClass('js-toggle-rounds-list') && $container.has(e.target).length === 0) {
				if ($container.hasClass('opened')) {
					$container.removeClass('opened');
				}
			}
		},

		toggleRoundsDropdown: function() {
			$(this.ui.dropdown_body).toggleClass('opened');
		},

		prevRound: function(e) {
			e.preventDefault();
			if (typeof  this.rounds.get(this.round_id - 1) != 'undefined') {
				this.round_id--;
				this.setSelectedRound().render(true);
			}

		},

		nextRound: function(e) {
			e.preventDefault();
			if (typeof  this.rounds.get(this.round_id + 1) != 'undefined') {
				this.round_id++;
				this.setSelectedRound().render(true);
			}
		},

		onDestroy: function(){
			this.hidePreloader();
		},

		render: function (event) {
			if (!event || this.isDestroyed) {
				return this;
			}

			this.$el.html(this.template({
				image_url: this.image_url,
				round_id: this.round_id,
				rounds: this.rounds.toJSON(),
				selected_round: this.selected_round
			}));

			return this;
		},

		setSelectedRound: function() {
			if (this.isDestroyed) {
				return this;
			}
			this.rounds.invoke('set', {"selected": false});
			if (!_.isNumber(this.round_id)) {
				this.round_id = this.rounds.getActualRoundId();
			}
			if (!_.isNumber(this.round_id)) {
				return this;
			}
			this.selected_round = this.rounds.get(this.round_id).set({'selected': true}).toJSON();
			this.showPreloader();

			APP.vent.trigger('tipping:round:change', this.round_id);
			this.filterRounds();

			return this;
		},

		changeRound: function(e) {
			this.round_id = $(e.currentTarget).data('round-id');

			this.setSelectedRound().render(true);
			return this;
		},

		callFillPopular: function() {
			APP.vent.trigger('tipping:fill_popular');
		}

	});

}(window, APP, Backbone, Marionette, $, _));
